module.exports = __webpack_public_path__ + "static/media/Storeplaystore.c768a201.svg";